import { ICoverageMatrixResponse } from 'types/api/coverageApi.interface'
import { IShiftCoverageSummaryResponse } from 'types/api/shiftCoverageApi.interface'
import { coveragePhaseKey, shiftWindowFrom, shiftWindowTo } from './coverageStatus'

export const deriveCoverageWidgetSummary = (matrix: ICoverageMatrixResponse): IShiftCoverageSummaryResponse => {
  const shifts = matrix.shifts
    .map((s) => {
      const deptCells = matrix.departments
        .map((d) => ({
          department: d.department,
          cell: d.coverageMatrixCells.find((c) => c.shift.id === s.id),
        }))
        .filter((x) => x.cell && x.cell.isStaffed)
      if (!deptCells.length) return null
      const required = deptCells.reduce((a, x) => a + (x.cell?.requiredTotal || 0), 0)
      const covered = deptCells.reduce((a, x) => a + (x.cell?.coveredTotal || 0), 0)
      const criticalGap = deptCells.some((x) => x.cell?.hasCriticalGap)
      const phase = coveragePhaseKey(deptCells[0]?.cell?.phase || 1)
      return {
        shiftId: s.id,
        name: s.name,
        windowFrom: shiftWindowFrom(s),
        windowTo: shiftWindowTo(s),
        phase,
        required,
        covered,
        confirmed: phase === 'future' ? covered : null,
        criticalGap,
        departments: deptCells.map((x) => {
          const gapRow = x.cell?.coverageMatrixRows.find((r) => r.isCritical && !r.isSatisfied)
          const gapName = gapRow ? gapRow.role?.name || gapRow.capability?.name || 'position' : null
          return {
            departmentId: x.department.id,
            name: x.department.name,
            required: x.cell?.requiredTotal || 0,
            covered: x.cell?.coveredTotal || 0,
            criticalGap: !!x.cell?.hasCriticalGap,
            gapLabel: gapName ? `${gapName}${phase === 'future' ? ' UNCONFIRMED' : ' unfilled'}` : null,
          }
        }),
      }
    })
    .filter(Boolean) as IShiftCoverageSummaryResponse['shifts']

  const staffedIds = new Set(shifts.map((s) => s.shiftId))
  return {
    siteName: matrix.site.name,
    shifts,
    shiftsWithoutRequirements: matrix.shifts
      .filter((s) => !staffedIds.has(s.id))
      .map((s) => ({ shiftId: s.id, name: s.name })),
  }
}
